import { filter, map, sumBy } from 'lodash';

import { formatMessage } from '@/utils/i18n';
import AppRegion from '@/types/app-region';
import { RowType, TaxAnalysisTableKeys, HoldingWithTaxData } from '../../types';

export const getTotalRow = (rows: HoldingWithTaxData[]): HoldingWithTaxData => {
  const sum = (key: string) => {
    const values = filter(map(rows, key), value => typeof value === 'number' && !isNaN(value));
    return values.length > 0 ? sumBy(values, v => v) : undefined;
  };

  return {
    _id: RowType.Total,
    [TaxAnalysisTableKeys.ComparisonItemId]: '',
    [TaxAnalysisTableKeys.Ticker]: formatMessage('Comparison.TaxAnalysis.TotalRowTicker'),
    [TaxAnalysisTableKeys.Units]: undefined,
    [TaxAnalysisTableKeys.CostBasis]: undefined,
    [TaxAnalysisTableKeys.MarketValue]: sum(TaxAnalysisTableKeys.MarketValue),
    [TaxAnalysisTableKeys.CurrentAllocation]: sum(TaxAnalysisTableKeys.CurrentAllocation),
    [TaxAnalysisTableKeys.ValueChange]: sum(TaxAnalysisTableKeys.ValueChange),
    [TaxAnalysisTableKeys.EstimatedRealizedGainLoss]: sum(TaxAnalysisTableKeys.EstimatedRealizedGainLoss),
    [TaxAnalysisTableKeys.TaxCostToReachTarget]: sum(TaxAnalysisTableKeys.TaxCostToReachTarget),
    [AppRegion.US]: {
      [TaxAnalysisTableKeys.ShortTermUnrealizedGainLoss]: sum(`${AppRegion.US}.${TaxAnalysisTableKeys.ShortTermUnrealizedGainLoss}`),
      [TaxAnalysisTableKeys.LongTermUnrealizedGainLoss]: sum(`${AppRegion.US}.${TaxAnalysisTableKeys.LongTermUnrealizedGainLoss}`),
      [TaxAnalysisTableKeys.TotalUnrealizedGainLoss]: sum(`${AppRegion.US}.${TaxAnalysisTableKeys.TotalUnrealizedGainLoss}`),
    },
    [AppRegion.CAN]: {
      [TaxAnalysisTableKeys.UnrealizedGainLoss]: sum(`${AppRegion.CAN}.${TaxAnalysisTableKeys.UnrealizedGainLoss}`),
    },
  };
};
